// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1__F1","cls2":"PaperContainer-cls2__bY PaperContainer-cls1__F1"};